module.exports = __webpack_public_path__ + "static/img/index_6.3acf2e5e.png";